var React = require('react');

function Burger (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.75 9h16.5m-16.5 6.75h16.5","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Burger.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = Burger;

Burger.default = Burger;
